import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { trackContentEngagement } from './MetaPixelTracker';
export function RecentPurchaseWidget() {
  const [currentCustomer, setCurrentCustomer] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  // List of fake customers with realistic Argentine names
  const customers = [{
    name: 'Pilar S.',
    age: 49,
    location: 'San Juan',
    timeAgo: '7 minutos'
  }, {
    name: 'Martín G.',
    age: 32,
    location: 'Palermo',
    timeAgo: '15 minutos'
  }, {
    name: 'Luciana F.',
    age: 28,
    location: 'Recoleta',
    timeAgo: '23 minutos'
  }, {
    name: 'Carlos B.',
    age: 45,
    location: 'San Telmo',
    timeAgo: '38 minutos'
  }, {
    name: 'Valeria M.',
    age: 37,
    location: 'Belgrano',
    timeAgo: '52 minutos'
  }, {
    name: 'Juan P.',
    age: 41,
    location: 'La Plata',
    timeAgo: '1 hora'
  }, {
    name: 'Gabriela D.',
    age: 34,
    location: 'Tigre',
    timeAgo: '1 hora'
  }, {
    name: 'Roberto A.',
    age: 52,
    location: 'Caballito',
    timeAgo: '2 horas'
  }];
  useEffect(() => {
    // Show for 4 seconds, hide for 4 seconds, total cycle of 8 seconds
    const interval = setInterval(() => {
      setIsVisible(prev => !prev); // Toggle visibility every 4 seconds
    }, 4000);
    // Change customer every 8 seconds (full cycle)
    const customerInterval = setInterval(() => {
      setCurrentCustomer(prev => (prev + 1) % customers.length);
    }, 8000);
    // Track first view
    trackContentEngagement('widget', 'recent_purchases', 'view');
    return () => {
      clearInterval(interval);
      clearInterval(customerInterval);
    };
  }, []);
  const customer = customers[currentCustomer];
  return <div className={`fixed bottom-4 left-4 bg-white text-black rounded-md shadow-sm p-2 max-w-[220px] border-l-2 border-red-500 transition-opacity duration-500 z-50 ${isVisible ? 'opacity-100' : 'opacity-0'}`} onClick={() => trackContentEngagement('widget', 'recent_purchases', 'click')} data-id="element-464">
      <div className="flex items-start" data-id="element-465">
        <CheckCircleIcon className="h-4 w-4 text-green-500 mr-1.5 flex-shrink-0 mt-0.5" data-id="element-466" />
        <div data-id="element-467">
          <p className="font-medium text-xs" data-id="element-468">Nueva compra</p>
          <p className="text-xs text-gray-600" data-id="element-469">
            {customer.name} de {customer.location} • {customer.timeAgo}
          </p>
        </div>
      </div>
    </div>;
}